import { ACCIONES } from '../utils/constantes';

export default {
  props: {
    nombreItem: {
      type: String,
      default: 'Recursos',
    },
  },
  computed: {
    titulo() {
      const nombreItem = this.nombreItem.toUpperCase();

      return this.form?.id ? `EDITAR ${nombreItem}` : `REGISTRAR ${nombreItem}`;
    },
  },
  data() {
    return {
      visible: false,
      form: this.generarObjetoFormRegistrar(),
      errores: [],
      guardando: false,
    };
  },
  methods: {
    generarObjetoFormRegistrar() {
      window.console.log('Implementar método "generarObjetoFormRegistrar" en el componente');
      return {};
    },
    generarObjetoFormEditar() {
      window.console.log('Implementar método "generarObjetoFormEditar" en el componente');
      return {};
    },
    abrirMixin(accion, data = null) {
      if (accion == ACCIONES.REGISTRAR) {
        this.form = this.generarObjetoFormRegistrar();
      }

      if (accion == ACCIONES.EDITAR) {
        this.form = this.generarObjetoFormEditar(data);
      }

      this.errores = [];
      this.visible = true;
    },
    cerrarMixin() {
      this.errores = [];
      this.visible = false;
    },
  },
};
